// -----------------------------------------------------------------------------
// Hyperform
//
// Hyperform is a pure JS implementation of the HTML 5 form validation API.
//
// Docs: https://hyperform.js.org/docs
// -----------------------------------------------------------------------------
import hyperform from 'hyperform';

export default () => {

  hyperform(window, {
    classes: {
      warning: 'error-message',
      validated: '-validated',
      valid: '-valid',
      invalid: '-invalid'
    }
  });

};
